import Cookies from 'js-cookie';
import apiClient from './api';

export const fetchAndSetCidadeEstadoCookie = async (userId) => {
	try {
		const resposta = await apiClient.get(`/usuario/${userId}`);
		const cidadeEstado =
			resposta.data?.cidadeEstado ||
			resposta.data?.usuario?.cidadeEstado ||
			resposta.data?.usuario?.cidadeestado ||
			'';

		if (cidadeEstado) {
			Cookies.set('cidadeEstadoUsuario', cidadeEstado, { expires: 7 });
		} else {
			Cookies.remove('cidadeEstadoUsuario');
		}

		return cidadeEstado;
	} catch (error) {
		console.error('Erro ao buscar cidade e estado do usuário:', error);
		Cookies.remove('cidadeEstadoUsuario');
		return '';
	}
};
